// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Redux:
import {
	requestCurrentPosition,
	setAllowMapOverride,
	getSearchData,
	searchAction,
	closeSearch,
	submitSearch,
	clearMapDetails,
	receiveData,
	receiveError
} from 'actions/search'

class SearchBar extends React.Component {
	componentWillMount() {
		// get the users location
		navigator.permissions &&
		navigator.permissions.query( { name: 'geolocation' } ).then( ( PermissionStatus ) => {
			if ( 'granted' === PermissionStatus.state ) {
				this.props.requestCurrentPosition()
			}
		})

		// close the search on back
		window.onpopstate = () => {
			this.props.handleCloseClick()
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.searchIsOpen && 'Churches Near Me' != this.props.searchTerm ) {
			this.searchInput.focus()
		}
	}

	handleChange = ( e ) => {
		this.props.handleChange( e.target.value )
	}

	handleSubmit = ( e ) => {
		// update the results
		this.props.handleSearch( this.props.searchTerm )

		if ( window.innerWidth <= siteData.mobile_max_width ) {
			this.searchInput.blur()
		}

		e.preventDefault()
	}

	handleKeyDown = ( e ) => {
		var isEscape = false
		var isSpace = false

		if ( 'key' in e ) {
			isEscape = ( e.key == 'Escape' || e.key == 'Esc' )
			isSpace = ( e.key == 'Space' || e.key == ' ' )
		} else {
			isEscape = ( e.keyCode == 27 )
			isSpace = ( e.keyCode == 32 )
		}

		if ( isEscape ) {
			this.props.handleCloseClick()
		}
	}

	handleCloseClick = () => {
		this.props.handleCloseClick()
	}

	handleSuggestionClick = ( e ) => {
		let text = e.target.getAttribute( 'data-text' )

		this.props.handleSuggestionClick( text )
		this.props.handleChange( text )

		e.preventDefault()
	}

	render() {
		const { translate, searchTerm } = this.props
		const searchPlaceholder = translate( 'Enter a location to find a church' )

		return (
			<div className="search-form">
				<form className="-form" action="" method="get" onSubmit={ this.handleSubmit }>
					<div className="-input">
						<input type="text"
							ref={ ( e ) => { this.searchInput = e } }
							value={ searchTerm }
							onChange={ this.handleChange }
							onKeyDown={ this.handleKeyDown }
							placeholder={ searchPlaceholder } />

						<i className="icon-close" onClick={ this.handleCloseClick } aria-hidden="true"></i>
					</div>

					<button className="button">
						<span className="-button-text">{ translate( 'Find' ) }</span>
						<i className="icon-search" aria-hidden="true"></i>
					</button>
				</form>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchIsOpen: state.search.isOpen,
		searchTerm: state.search.searchTerm
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		requestCurrentPosition: () => {
			dispatch( requestCurrentPosition() )
		},

		handleChange: ( searchTerm ) => {
			dispatch( searchAction( searchTerm ) )
		},

		handleSuggestionClick( searchTerm ) {
			let searchArgs = {
				allowMapOverride: true,
				blockUI: true
			}

			dispatch( setAllowMapOverride( true ) )
			dispatch( searchAction( searchTerm ) )
			dispatch( getSearchData( searchTerm, searchArgs ) )
		},

		handleSearch: ( searchTerm, args ) => {
			let searchArgs = {
				allowMapOverride: true,
				blockUI: true
			}

			// when searching from the search bar input,
			// allow the response to override/set the state of the map
			// (eg. map center, zoom)
			dispatch( setAllowMapOverride( true ) )

			dispatch( clearMapDetails() )
			dispatch( getSearchData( searchTerm, searchArgs ) )
		},

		handleSubmit() {
			dispatch( submitSearch() )
		},

		handleCloseClick() {
			dispatch( closeSearch() )
		}
	}
}

export default localize(
	connect( mapStateToProps, mapDispatchToProps )( SearchBar )
)



// WEBPACK FOOTER //
// ./components/Search/SearchBar.jsx